import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { BbotButton, BbotModal, Checkbox } from "top-component-library";

// Mirrors disconnect-integration-dialog.html, shared by Omnivore MMS/Direct/3's
// disconnect flow (admin-only).
const DisconnectIntegrationDialog = ({ visible, integrationName, onClose, onConfirm }) => {
  const [deleteMenuItems, setDeleteMenuItems] = useState(false);
  const [disconnecting, setDisconnecting] = useState(false);

  // This dialog is always mounted (only BbotModal's own visible prop hides it), so without
  // this it would silently carry a checked box into the next, unrelated disconnect attempt.
  useEffect(() => {
    if (visible) setDeleteMenuItems(false);
  }, [visible]);

  const handleConfirm = async () => {
    setDisconnecting(true);
    const succeeded = await onConfirm(deleteMenuItems);
    setDisconnecting(false);
    if (succeeded) onClose();
  };

  return (
    <BbotModal
      title={`Disconnect ${integrationName}?`}
      visible={visible}
      onCancel={onClose}
      footer={[
        <BbotButton key="cancel" onClick={onClose}>
          Never mind, go back!
        </BbotButton>,
        <BbotButton key="confirm" type="primary" danger loading={disconnecting} onClick={handleConfirm}>
          Confirm
        </BbotButton>,
      ]}
    >
      <p>Are you sure you want to disconnect {integrationName}?</p>
      <Checkbox checked={deleteMenuItems} onChange={(event) => setDeleteMenuItems(event.target.checked)}>
        Delete existing menu items that came from {integrationName}
      </Checkbox>
    </BbotModal>
  );
};

DisconnectIntegrationDialog.propTypes = {
  visible: PropTypes.bool.isRequired,
  integrationName: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

export default DisconnectIntegrationDialog;
